/* SPQR SHOP only. Anonymous behavioral analytics; no customer or engraving values. */
(() => {
  'use strict';
  const TOKEN = 'phc_kk9L8b6dDCqfbBLTXJcXhAjBkXSZ8574FvmEqUcx9sB9';
  const VERSION = 'spqr-2026-09-25-v1';
  const BRIDGE = 'spqr_ph_bridge_v1', ATTR = 'spqr_ph_attribution_v1';
  if (window.spqrPostHogInstalled || !/^(www\.)?spqrshop\.com$/.test(location.hostname)) return;
  if (/^\/(account|challenge|checkouts?)(\/|$)/.test(location.pathname)) return;
  window.spqrPostHogInstalled = true;
  const config = document.querySelector('[data-spqr-posthog]');
  const page = location.pathname;
  const params = new URLSearchParams(location.search);
  const privateSelector = 'input,textarea,select,[contenteditable],.ph-no-capture,.ph-mask,.cart__item--properties,[data-engraving-input],[data-spqr-custom-input],[data-spqr-engraving],form[action*="/contact"]';
  let ph, started = false, allowed = false, attribution = {}, qa = false;
  let pageviewID, activeSeconds = 0, visibleSeconds = 0, lastTick = performance.now(), lastInput = performance.now();
  let maximumScroll = 0, flushedAt = performance.now(), bridgeAt = 0;
  const scrollSent = new Set(), sectionSeen = new Set(), sectionTimers = new Map();
  const getJSON = key => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const putJSON = (key, val) => { try { localStorage.setItem(key, JSON.stringify(val)); } catch (_) {} };
  const cleanText = value => String(value || '').replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi, '[redacted]').replace(/ph[xcs]_[\w-]+/g, '[redacted]').slice(0,180);
  function cleanURL(value) {
    try {
      const u = new URL(value, location.origin);
      if (!/^https?:$/.test(u.protocol)) return '';
      const path = /^\/(account|checkouts?)(\/|$)/.test(u.pathname) ? '/private' : u.pathname;
      return u.origin + path;
    } catch (_) { return ''; }
  }
  function consentAllowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch (_) { return false; }
  }
  function saveBridge() {
    if (!ph || !allowed) return;
    const data = {distinct_id:ph.get_distinct_id(),session_id:ph.get_session_id(),
      pageview_id:pageviewID,attribution,spqr_qa:qa,updated_at:Date.now()};
    putJSON(BRIDGE, data);
    try { document.cookie = BRIDGE+'='+encodeURIComponent(JSON.stringify(data))+'; Path=/; Max-Age=1800; SameSite=Lax; Secure; Domain=spqrshop.com'; } catch (_) {}
    bridgeAt = Date.now();
  }
  function capture(event, props = {}, instant = false) {
    if (!allowed || !ph || !consentAllowed()) return;
    if (Date.now()-bridgeAt > 10000) saveBridge();
    ph.capture(event, {...attribution, page, page_type:config?.dataset.pageType || 'other',
      pageview_id:pageviewID, theme_id:config?.dataset.themeId, measurement_version:VERSION,
      spqr_qa:qa, traffic_type:qa?'internal':'customer', ...props}, instant ? {send_instantly:true} : undefined);
  }
  function tick() {
    const now=performance.now(), seconds=Math.min(2,Math.max(0,(now-lastTick)/1000));
    lastTick=now;
    if (!allowed || document.visibilityState !== 'visible') return;
    visibleSeconds+=seconds;
    if (document.hasFocus() && now-lastInput<=30000) activeSeconds+=seconds;
  }
  function flush(reason) {
    tick();
    if (visibleSeconds<0.1 || !allowed) return;
    capture('page_attention',{active_seconds:Math.round(activeSeconds*10)/10,
      visible_seconds:Math.round(visibleSeconds*10)/10,max_scroll_percent:maximumScroll,reason},true);
    activeSeconds=0; visibleSeconds=0; flushedAt=performance.now();
  }
  function scrollDepth() {
    const available=document.documentElement.scrollHeight-innerHeight;
    const pct=available>0?Math.min(100,Math.round(scrollY/available*100)):100;
    maximumScroll=Math.max(maximumScroll,pct);
    [25,50,75,90,100].forEach(threshold=>{
      if(pct>=threshold&&!scrollSent.has(threshold)&&allowed){scrollSent.add(threshold);capture('scroll_depth',{scroll_percent:threshold});}
    });
  }
  function setupBehavior() {
    ['pointerdown','keydown','scroll','touchstart'].forEach(name=>document.addEventListener(name,()=>{lastInput=performance.now();},{passive:true}));
    document.addEventListener('scroll',scrollDepth,{passive:true});
    setInterval(()=>{tick();if(performance.now()-flushedAt>=15000)flush('heartbeat');if(allowed&&Date.now()-bridgeAt>15000)saveBridge();},1000);
    document.addEventListener('visibilitychange',()=>{if(document.hidden){flush('hidden');sectionTimers.forEach(clearTimeout);sectionTimers.clear();}else{lastTick=performance.now();lastInput=lastTick;observeSections();}});
    window.addEventListener('pagehide',()=>flush('pagehide'));
    document.addEventListener('click',event=>{
      const el=event.target.closest?.('a,button,summary,[role="button"]');
      if(!el||el.closest(privateSelector))return;
      const label=cleanText(el.getAttribute('aria-label')||el.querySelector('[data-add-to-cart-text]')?.textContent||el.textContent).trim().replace(/\s+/g,' ').slice(0,100);
      const section=el.closest('[id^="shopify-section-"]')?.id||'global';
      const target=el.href?cleanURL(el.href):'';
      capture('interaction_click',{element_id:cleanText(el.id||el.getAttribute('data-spqr-journey')||el.getAttribute('name')||el.tagName.toLowerCase()+':'+label),label,section,target_path:target?new URL(target).pathname:'',element_tag:el.tagName.toLowerCase()});
      if(el.matches('[data-add-to-cart],[name="add"]'))capture('add_to_cart_clicked');
      if(el.matches('[data-spqr-buy-now],[name="checkout"]')||/\/checkout\b/.test(el.getAttribute('href')||''))capture('checkout_clicked');
      if(el.matches('[data-engraving-toggle]'))capture('engraving_opened');
    },true);
    document.addEventListener('change',event=>{
      const el=event.target;
      if(!el.matches?.('input[name="Size"],input[name="Material"],select[name="Size"],select[name="Material"],select[name="sort_by"],input[name^="filter."]'))return;
      capture(el.name==='sort_by'||el.name.startsWith('filter.')?'collection_filter_changed':'product_option_selected',
        {option_name:cleanText(el.name),option_value:cleanText(el.value),product_id:config?.dataset.productId||undefined});
    });
    document.addEventListener('spqr:journey',event=>capture('discovery_interaction',{action:cleanText(event.detail?.action),subject:cleanText(event.detail?.subject)}));
    document.addEventListener('ajaxProduct:error',()=>capture('cart_error',{error_type:'add_to_cart_failed'}));
    document.addEventListener('cart:open',()=>capture('cart_drawer_opened'));
    const errorSeen=new WeakSet();
    new MutationObserver(()=>{
      document.querySelectorAll('[data-spqr-checkout-error],.errors,.product-form__error-message-wrapper').forEach(el=>{
        if(!el.hidden&&el.offsetHeight>0&&el.textContent.trim()&&!errorSeen.has(el)){errorSeen.add(el);capture('cart_error',{error_type:/size/i.test(el.textContent)?'size_required':'purchase_form_error'});}
      });
    }).observe(document.body,{subtree:true,attributes:true,attributeFilter:['hidden','class'],childList:true});
    document.querySelectorAll('video').forEach((el,index)=>{
      ['play','pause','ended'].forEach(action=>el.addEventListener(action,()=>capture('video_engagement',{action,video_index:index,video_path:cleanURL(el.currentSrc),video_seconds:Math.round(el.currentTime)})));
    });
    observeSections();scrollDepth();
  }
  let sectionObserver;
  function observeSections() {
    if(!window.IntersectionObserver)return;
    sectionObserver?.disconnect();
    sectionObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
      const id=entry.target.id;
      if(!entry.isIntersecting){clearTimeout(sectionTimers.get(id));sectionTimers.delete(id);return;}
      if(sectionSeen.has(id)||sectionTimers.has(id)||document.hidden)return;
      sectionTimers.set(id,setTimeout(()=>{sectionTimers.delete(id);if(!allowed||document.hidden)return;sectionSeen.add(id);capture('section_exposed',{section:id,exposure_seconds:2});},2000));
    }),{threshold:0.1});
    document.querySelectorAll('main [id^="shopify-section-"]').forEach(el=>sectionObserver.observe(el));
  }
  function start() {
    if(started||!consentAllowed())return;
    started=true;allowed=true;
    try {
      if(params.get('spqr_qa')==='1')sessionStorage.setItem('spqr_qa','true');
      if(params.get('spqr_qa')==='0')sessionStorage.removeItem('spqr_qa');
      qa=sessionStorage.getItem('spqr_qa')==='true'||window.Shopify?.designMode===true||window.Shopify?.theme?.role!=='main';
    } catch (_) { qa=params.get('spqr_qa')==='1'; }
    const old=getJSON(ATTR), fresh={};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','campaign_id','adset_id','ad_id'].forEach(key=>{const value=params.get(key);if(value)fresh[key]=cleanText(value);});
    let ref='';try{ref=new URL(document.referrer).hostname;}catch(_){}
    if(!fresh.utm_source&&params.has('gclid'))Object.assign(fresh,{utm_source:'google',utm_medium:'cpc'});
    if(!fresh.utm_source&&params.has('fbclid'))Object.assign(fresh,{utm_source:'facebook',utm_medium:'social'});
    if(Object.keys(fresh).length){attribution={...fresh,landing_page:page,attribution_updated_at:Date.now()};putJSON(ATTR,attribution);}
    else if(old&&Date.now()-old.attribution_updated_at<90*86400000)attribution=old;
    else attribution={utm_source:ref&&!/^(www\.)?spqrshop\.com$/.test(ref)?ref:'direct',utm_medium:ref?'referral':'none',landing_page:page,attribution_updated_at:Date.now()};
    const sdk=document.createElement('script');sdk.async=true;sdk.src='https://eu-assets.i.posthog.com/static/array.js';
    sdk.onload=()=>{
      if(!consentAllowed()){started=false;allowed=false;return;}
      window.posthog.init(TOKEN,{
        api_host:'https://eu.i.posthog.com',ui_host:'https://eu.posthog.com',defaults:'2026-05-30',
        person_profiles:'identified_only',capture_pageview:false,capture_pageleave:true,
        autocapture:{dom_event_allowlist:['click','submit'],element_attribute_ignorelist:['value','href','src','title'],capture_copied_text:false},
        mask_all_text:true,mask_all_element_attributes:true,capture_heatmaps:true,capture_dead_clicks:true,
        mask_personal_data_properties:true,custom_personal_data_properties:Array.from(params.keys()).filter(key=>!/^utm_|^(campaign_id|adset_id|ad_id|variant|view|spqr_qa)$/.test(key)),
        capture_performance:{web_vitals:true,network_timing:false},capture_exceptions:true,
        persistence:'localStorage+cookie',cookie_expiration:90,disable_surveys:true,
        enable_recording_console_log:false,
        session_recording:{maskAllInputs:true,maskTextSelector:privateSelector,blockSelector:'iframe,input[type="hidden"],input[type="file"],form[action*="/contact"],.cart__item--properties',recordCrossOriginIframes:false,recordHeaders:false,recordBody:false,streamNetworkBody:false,captureJsonLd:false,
          maskCapturedNetworkRequestFn:request=>request.isInitial?{...request,name:cleanURL(request.name),requestBody:undefined,responseBody:undefined,requestHeaders:undefined,responseHeaders:undefined}:null,
          maskAttributeFn:(name,value,el)=>{
            if(/^(href|action)$/i.test(name))return cleanURL(value);
            if(/value|email|phone|customer|engraving|token|password/i.test(name)||el?.matches?.('input,textarea,select'))return '[redacted]';
            return value;
          }},
        before_send:event=>{
          if(!consentAllowed())return null;
          const scrub=(value,key,depth)=>{
            if(depth>15)return value;
            if(typeof value==='string'){
              if(/pathname/i.test(key)){try{return new URL(cleanURL(value)).pathname;}catch(_){return '';}}
              if(/url|href|referrer/i.test(key))return cleanURL(value);
              return value.replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi,'[redacted]').replace(/ph[xs]_[\w-]+/g,'[redacted]');
            }
            if(Array.isArray(value))return value.map(v=>scrub(v,key,depth+1));
            if(value&&typeof value==='object'){Object.keys(value).forEach(k=>{if(/^(email|phone|address|engraving|customer|token|password)$/i.test(k))delete value[k];else value[k]=scrub(value[k],k,depth+1);});}
            return value;
          };
          if(event.event!=='$snapshot')scrub(event.properties,'',0);
          // PostHog requires its public ingest token after before_send.
          event.properties.token=TOKEN;
          event.properties.spqr_qa=qa;event.properties.measurement_version=VERSION;
          return event;
        },
        loaded:instance=>{
          ph=instance;window.spqrPostHog=instance;pageviewID=crypto.randomUUID();
          ph.register({...attribution,page,page_type:config?.dataset.pageType||'other',pageview_id:pageviewID,spqr_qa:qa,measurement_version:VERSION});
          saveBridge();capture('$pageview');lastTick=performance.now();lastInput=lastTick;flushedAt=lastTick;setupBehavior();
        }
      });
    };
    sdk.onerror=()=>{started=false;};document.head.appendChild(sdk);
  }
  function consentChanged() {
    const ok=consentAllowed();
    if(!ok){allowed=false;activeSeconds=0;visibleSeconds=0;ph?.stopSessionRecording();ph?.opt_out_capturing();
      try{localStorage.removeItem(BRIDGE);localStorage.removeItem(ATTR);document.cookie=BRIDGE+'=; Path=/; Max-Age=0; Domain=spqrshop.com';}catch(_){}
    }else if(ph){allowed=true;ph.opt_in_capturing({captureEventName:false});ph.startSessionRecording();saveBridge();}
    else start();
  }
  document.addEventListener('visitorConsentCollected',consentChanged);
  if(window.Shopify?.customerPrivacy)start();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)start();});
})();
